/* eslint-disable max-len */
import React, { useState } from 'react';
import { useEffectOnce, useSearchParam } from 'react-use';
import styled, { css } from 'styled-components';
import { useParams } from 'wouter';
import { Images } from '../../@resources/img';
import { Observer } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { ApiClient } from '../../api/ApiClient';
import { Box, Colors } from '../../ui';
import { Check } from '../../ui/Check';
import { LoadingBar } from '../../ui/LoadingBar';
import { useResolve } from '../Container';
import { Copy, Em, Flexer } from '../dashboard/elements/LayoutElements';
import { SetupProcess } from './SetupProcess';

const Frame = styled.div`
    background: #eff3f6;    
    min-height: 100vh;
`;

const Branding = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Rubik';
    font-size: 3rem;
    font-weight: 450;
    color: ${Colors.primary};
    margin-bottom: 1rem;
    transform: translateY(9rem);

    img {
        width: 5rem;
        height: 5rem;
        margin-right: .5rem;
    }
`;

const WaitingFrame = styled.div<{ visible: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 10rem;
    pointer-events: none;

    ${Branding} {
        position: static;
        transform: none;
    }

    opacity: ${p => p.visible ? 1 : 0};
    transition: opacity 300ms linear;
`;

const WaitingLoader = styled.div<{ show: boolean }>`
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: 18rem;
    text-align: center;
    transition: all 200ms ease-out;
    opacity: 1;

    ${p => p.show ? '' : css`
        transform: translate(-50%) scale(0.5);
        opacity: 0;
    `}
`;

const WaitingMessage = styled.div<{ show: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -2rem);
    width: 18rem;
    opacity: 0;
    transition: all 200ms ease-out;

    ${p => !p.show ? '' : css`
        transform: translate(-50%, 0rem);
        opacity: 1;
    `}
`;

const CreatingView: LFC<{ process?: SetupProcess }> = ({ process }) => {
    return <WaitingFrame visible={!!process}>
        <Branding id="branding-final">
            <img src={Images.LogoBlue} />
            Metro Retro
        </Branding>
        {!!process && <Observer store={process} render={x =>
            <Flexer relative>
                <WaitingLoader show={!x.done} >
                    <Box margin=".5 0" width="18">
                        <LoadingBar color={Colors.primary} progress={x.progress} />
                    </Box>
                    <Copy><Em>Getting things ready...</Em></Copy>
                </WaitingLoader>
                <WaitingMessage show={x.done}>
                    <Check value={true} />
                    <Box padding="0 1">
                        <Copy flush size="1.5">Setup complete!</Copy>
                    </Box>
                </WaitingMessage>
                {/* {x.done && <audio autoPlay playsInline src={Sounds.KnockSuccess} />} */}
            </Flexer>
        } />}
    </WaitingFrame>;
};

// Enable when ready:

// export const SetupPage = () => {
//     const { entityId } = useParams<{ entityId: string }>();
//     const surveyId = useSearchParam('survey') as string;
//     const trial = useSearchParam('trial') !== '0';
//     const api = useResolve(ApiClient);
//     const [process, setProcess] = useState(null as SetupProcess);

//     useEffectOnce(() => {
//         const sp = new SetupProcess(api, entityId, trial ? '2024' : null);
//         setProcess(sp);
//         sp.go({ name: null, invites: [], surveyId }).then(to => window.location.href = to);
//     });

//     return <Frame>
//         <CreatingView process={process} />
//     </Frame>;
// };

export const SetupPage = () => {
    const { entityId } = useParams<{ entityId: string }>();
    const surveyId = useSearchParam('survey') as string;
    const trial = useSearchParam('trial') !== '0';
    const api = useResolve(ApiClient);
    const [process, setProcess] = useState(null as SetupProcess);

    useEffectOnce(() => {
        const sp = new SetupProcess(api, entityId, trial ? 'host' : null);
        setProcess(sp);
        sp.go({ name: null, invites: [], surveyId }).then(to => window.location.href = to);
    });

    return <Frame>
        <CreatingView process={process} />
    </Frame>;
};

